import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import Login from '../login';
import loader from '../../common/loader';
import { isObject, isString } from '../../common/base';
import _Object from '../../common/object';
import { requestRole } from './api';
import cookie from '../../common/cookie';
import loginStatus from '../../common/loginStatus';
import miloUrl from '../../common/url';
var areaConfigCache = {
  data: {},
  get: function get(gameId) {
    if (gameId && this.data[gameId]) {
      return this.data[gameId];
    }

    return null;
  },
  set: function set(gameId, data) {
    if (gameId) {
      this.data[gameId] = data;
    }
  }
}; // 指定业务aci地址

var game2Url = {
  cf: "".concat(location.protocol, "//cf.aci.game.qq.com/main"),
  lol: "".concat(location.protocol, "//lol.aci.game.qq.com/main"),
  yxzj: "".concat(location.protocol, "//yxzj.aci.game.qq.com/main")
}; // 默认aci地址

var urlDefault = "".concat(location.protocol, "//comm.aci.game.qq.com/main"); // 获取活动当前的无参数的URL

var getActivityReportUrl = function getActivityReportUrl(url) {
  url = isString(url) ? url : location.href;
  url = url.split('?')[0];
  url = url.split('#')[0];
  return url;
}; // 私有方法 通过参数查询角色
// oRoleSelector  : 实例对象(如果有)


var _queryRoleByParams = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var opts,
        LoginManager,
        _LoginManager$getLogi,
        acctype,
        access_token,
        openid,
        appid,
        openToOpen,
        gameId,
        request,
        submitData,
        k,
        _k,
        channelid,
        _k2,
        _k3,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            LoginManager = new Login();
            _LoginManager$getLogi = LoginManager.getLoginStatusParams(), acctype = _LoginManager$getLogi.acctype, access_token = _LoginManager$getLogi.access_token, openid = _LoginManager$getLogi.openid, appid = _LoginManager$getLogi.appid;
            openToOpen = opts.openToOpen, gameId = opts.gameId, request = opts.request;
            submitData = {};

            if ('object' === _typeof(openToOpen.oGopenidParams)) {
              for (k in openToOpen.oGopenidParams) {
                submitData[k] = openToOpen.oGopenidParams[k];
              }
            }

            if ('object' === _typeof(openToOpen.oRailidParams)) {
              for (_k in openToOpen.oRailidParams) {
                submitData[_k] = openToOpen.oRailidParams[_k];
              }
            }

            if (openToOpen) {
              if (openToOpen.sAMSTrusteeship) {
                if (LoginManager.isMSDKLogin()) {
                  // add by weiztang 20220707 增加msdk下转其他业务参数
                  if (openToOpen.msdkTrusteeship) {
                    submitData.msdkTrusteeship = 1;
                    submitData.sAMSTrusteeship = openToOpen.sAMSTrusteeship;
                    channelid = miloUrl.request('channelid');

                    if (channelid == '1') {
                      // wx
                      submitData.sAMSTargetAppId = openToOpen.ams_targetappid_wx || '';
                    } else if (channelid == '2') {
                      // qq
                      submitData.sAMSTargetAppId = openToOpen.ams_targetappid_qc || '';
                    }
                  }
                } else if ('wx' == acctype && openid && access_token && openToOpen.ams_targetappid_wx) {
                  // 微信托管
                  submitData.sAMSAcctype = 'wx';
                  submitData.sAMSAccessToken = access_token || '';
                  submitData.sAMSAppOpenId = openid || '';
                  submitData.sAMSTargetAppId = openToOpen.ams_targetappid_wx || '';
                } else if (openid && access_token && appid && openToOpen.ams_targetappid_qc) {
                  // QQ互联托管
                  submitData.sAMSAcctype = 'qq';
                  submitData.sAMSAccessToken = access_token;
                  submitData.sAMSAppOpenId = openid;
                  submitData.sAMSTargetAppId = openToOpen.ams_targetappid_qc || '';
                  submitData.sAMSSourceAppId = appid; // aci同时转换成openid和uin供下游使用

                  submitData.openid = '<sAMSGameOpenId>';
                  submitData.iUin = '<sAMSGameOpenId>';
                  submitData.uin = '<sAMSGameOpenId>';
                } else if ('mini' == acctype) {
                  submitData.sAMSAcctype = 'mini';
                  submitData.openid = openid || '';
                  submitData.sAMSTargetAppId = openToOpen.ams_targetappid_wx || '';
                } else if ('qqmini' == acctype) {
                  submitData.sAMSAcctype = 'qqmini';
                  submitData.openid = openid || '';
                  submitData.sAMSTargetAppId = openToOpen.ams_targetappid_qc || '';
                  submitData.uin = openid || '';
                }
              } else {
                // 老版的微信openid转换
                if ('wx' == acctype) {
                  for (_k2 in openToOpen) {
                    if (!isObject(openToOpen)) {
                      submitData[_k2] = openToOpen[_k2];
                    }
                  }
                }
              }
            } // gameid


            submitData.game = gameId.toLowerCase();
            submitData.sCloudApiName = 'ams.gameattr.role'; // area plat partition等

            for (_k3 in request) {
              submitData[_k3] = request[_k3];
            }

            opts.submitData = submitData;
            _context.next = 14;
            return requestRole(opts);

          case 14:
            return _context.abrupt("return", _context.sent);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function _queryRoleByParams() {
    return _ref.apply(this, arguments);
  };
}();

var RoleSelector = {
  getAreaData: function getAreaData(config) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var roleData, gameId, charset, logtype, oriAreaData, oriAreaDataJson, filterAreaData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              roleData = {
                areaIndex: [],
                // 当前选中的序号组
                areaFields: [],
                roleArray: [],
                // 原始大区配置信息
                oriAreaData: {},
                // 格式化之后的大区配置信息
                formatedAreaData: {}
              };
              gameId = config.gameId, charset = config.charset, logtype = config.logtype;
              _context2.next = 4;
              return _this.getOriAreaConfig(gameId, charset, logtype);

            case 4:
              oriAreaData = _context2.sent;
              oriAreaDataJson = JSON.stringify(oriAreaData);
              filterAreaData = JSON.parse(oriAreaDataJson);
              _context2.next = 9;
              return _this.filterAreaConfig(config, filterAreaData);

            case 9:
              oriAreaData = _context2.sent;
              roleData.oriAreaData = filterAreaData;
              return _context2.abrupt("return", _this.formatAreaData(roleData));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  queryRoleByParams: function queryRoleByParams(opts, callback) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              opts.callback = callback;
              return _context3.abrupt("return", _queryRoleByParams(opts));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /* 过滤指定的channel,system等*/
  filterAreaConfig: function filterAreaConfig(config, oriAreaData) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var filterSystem, filterChannel, doFilter;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              filterSystem = config.filterSystem;
              filterChannel = config.filterChannel;

              doFilter = function doFilter(loginType) {
                if ('auto' == filterChannel) {
                  filterChannel = loginType;
                } // channel过滤


                if (/^(qq|weixin)$/.test(filterChannel)) {
                  // STD_CHANNEL
                  if (oriAreaData.STD_CHANNEL_DATA && oriAreaData.STD_CHANNEL_DATA.length) {
                    var i = 0;

                    while (i < oriAreaData.STD_CHANNEL_DATA.length) {
                      if (oriAreaData.STD_CHANNEL_DATA[i].k && oriAreaData.STD_CHANNEL_DATA[i].k != filterChannel) {
                        oriAreaData.STD_CHANNEL_DATA.splice(i, 1);
                      } else {
                        i = i + 1;
                      }
                    }
                  } // STD_DATA


                  if (oriAreaData.STD_DATA && oriAreaData.STD_DATA.length) {
                    var _i = 0;

                    while (_i < oriAreaData.STD_DATA.length) {
                      if (oriAreaData.STD_DATA[_i].ck && oriAreaData.STD_DATA[_i].ck != filterChannel) {
                        oriAreaData.STD_DATA.splice(_i, 1);
                      } else {
                        _i = _i + 1;
                      }
                    }
                  }
                } // system 过滤


                if (/^(ios|android)$/.test(filterSystem)) {
                  // STD_SYSTEM
                  if (oriAreaData.STD_SYSTEM_DATA && oriAreaData.STD_SYSTEM_DATA.length) {
                    var _i2 = 0;

                    while (_i2 < oriAreaData.STD_SYSTEM_DATA.length) {
                      if (oriAreaData.STD_SYSTEM_DATA[_i2].k && oriAreaData.STD_SYSTEM_DATA[_i2].k != filterSystem) {
                        oriAreaData.STD_SYSTEM_DATA.splice(_i2, 1);
                      } else {
                        _i2 = _i2 + 1;
                      }
                    }
                  } // STD_CHANNEL


                  if (oriAreaData.STD_CHANNEL_DATA && oriAreaData.STD_CHANNEL_DATA.length) {
                    var _i3 = 0;

                    while (_i3 < oriAreaData.STD_CHANNEL_DATA.length) {
                      if (oriAreaData.STD_CHANNEL_DATA[_i3].sk && oriAreaData.STD_CHANNEL_DATA[_i3].sk != filterSystem) {
                        oriAreaData.STD_CHANNEL_DATA.splice(_i3, 1);
                      } else {
                        _i3 = _i3 + 1;
                      }
                    }
                  } // STD_DATA


                  if (oriAreaData.STD_DATA && oriAreaData.STD_DATA.length) {
                    var _i4 = 0;

                    while (_i4 < oriAreaData.STD_DATA.length) {
                      if (oriAreaData.STD_DATA[_i4].sk && oriAreaData.STD_DATA[_i4].sk != filterSystem) {
                        oriAreaData.STD_DATA.splice(_i4, 1);
                      } else {
                        _i4 = _i4 + 1;
                      }
                    }
                  }
                } // this.setRoleData({
                // 	oriAreaData
                // });


                var filterData = _objectSpread({}, oriAreaData);

                return filterData;
              };

              return _context4.abrupt("return", new Promise(function (resolve) {
                if ('auto' == filterChannel) {
                  // 判断登录态
                  var LoginManager = new Login();
                  LoginManager.checkLogin().then(function (_ref2) {
                    var acctype = _ref2.acctype;

                    if ('wx' == acctype) {
                      resolve(doFilter('weixin'));
                    } else if ('pt' == acctype || 'qc' == acctype) {
                      resolve(doFilter('qq'));
                    } else {
                      resolve(doFilter(''));
                    }
                  })["catch"](function (err) {
                    console.log(err);
                    resolve(doFilter(''));
                  });
                } else {
                  resolve(doFilter(''));
                }
              }));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /*
    	@method getOriAreaConfig
    	@params gameId 游戏业务代码，默认为config.gameId
    	@params callback 拉取到大区配置文件后的回调
    	@desc 拉取大区配置文件
  */
  getOriAreaConfig: function getOriAreaConfig(gameId, charset, logtype) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var withLogType, url;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (gameId) {
                _context5.next = 2;
                break;
              }

              throw '请传入gameId';

            case 2:
              charset = charset || 'gbk'; // 检查缓存数据

              if (!areaConfigCache.get(gameId)) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt("return", areaConfigCache.get(gameId));

            case 5:
              withLogType = logtype ? "".concat(logtype, "_") : '';
              url = "https://gameact.qq.com/comm-htdocs/js/game_area/".concat(gameId, "_").concat(withLogType, "server_select.js");

              if ('utf8' == charset) {
                url = "https://gameact.qq.com/comm-htdocs/js/game_area/utf8verson/".concat(gameId, "_").concat(withLogType, "server_select_utf8.js");
              } // 获取大区配置信息


              return _context5.abrupt("return", loader.loadScript({
                url: url,
                charset: charset
              }).then(function () {
                // change by weiztang 填坑，loader.loadScript只有一个入参 20220818
                var dataName = '';

                if (/^(\d)/.test(gameId)) {
                  dataName = "_".concat(gameId.toUpperCase(), "ServerSelect");
                } else {
                  dataName = "".concat(gameId.toUpperCase(), "ServerSelect");
                }

                var data = window[dataName];
                areaConfigCache.set(gameId, data);
                return data;
              }));

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /*
     @method formatAreaData
     @desc 格式化大区配置文件
  */
  formatAreaData: function formatAreaData(roleData) {
    var areaFields = []; // 渠道

    if (roleData.oriAreaData.STD_CHANNEL_DATA && roleData.oriAreaData.STD_CHANNEL_DATA.length) {
      areaFields.push({
        fieldName: '渠道',
        // 字段名
        fieldKey: 'area',
        requestKey: 'area' // 请求的时候带上的字段名，空就不带

      });
    } // 系统


    if (roleData.oriAreaData.STD_SYSTEM_DATA && roleData.oriAreaData.STD_SYSTEM_DATA.length) {
      areaFields.push({
        fieldName: '系统',
        // 字段名
        fieldKey: 'platid',
        requestKey: 'platid' // 请求的时候带上的字段名，空就不带

      });
    } // 大区


    if (roleData.oriAreaData.STD_DATA && roleData.oriAreaData.STD_DATA.length) {
      // 如果只有大区，没有渠道/系统，则requestKey='area'
      if (!areaFields.length) {
        areaFields.push({
          fieldName: '大区',
          fieldKey: 'partition',
          requestKey: 'area'
        });
      } else {
        areaFields.push({
          fieldName: '大区',
          fieldKey: 'partition',
          requestKey: 'partition'
        });
      } // 二级大区就是服务器


      if (roleData.oriAreaData.STD_DATA[0].opt_data_array && roleData.oriAreaData.STD_DATA[0].opt_data_array.length) {
        // 一级大区requestKey置空
        areaFields[areaFields.length - 1].requestKey = '';
        areaFields.push({
          fieldName: '服务器',
          fieldKey: 'server',
          requestKey: 'area'
        });
      }
    }

    var indexArray = [];

    for (var i = 0; i < areaFields.length; i++) {
      indexArray.push('empty');
    } // this.setRoleData({
    // 	areaFields: areaFields,
    // 	areaIndex: indexArray
    // });


    roleData = _objectSpread(_objectSpread({}, roleData), {}, {
      areaFields: areaFields,
      areaIndex: indexArray
    });
    var formatedAreaData = {}; // 根据channel,system,partition综合选择大区/服务器

    var filterData = function filterData(_ref3) {
      var channel = _ref3.channel,
          system = _ref3.system,
          partition = _ref3.partition;
      var rtData = [];

      if (partition) {
        // 有大区，找到指定大区
        var selected = [];

        for (var _i5 = 0; _i5 < roleData.oriAreaData.STD_DATA.length; _i5++) {
          if (partition == roleData.oriAreaData.STD_DATA[_i5].v) {
            selected = roleData.oriAreaData.STD_DATA[_i5].opt_data_array;
            break;
          }
        } // 找到大区了，找服务器


        if (selected.length) {
          for (var _i6 = 0; _i6 < selected.length; _i6++) {
            if (channel && selected[_i6].c && channel != selected[_i6].c) {
              continue;
            }

            if (system && selected[_i6].s && system != selected[_i6].s) {
              continue;
            }

            rtData.push({
              v: selected[_i6].v,
              t: selected[_i6].t
            });
          }
        }

        if (rtData.length) {
          rtData.unshift({
            v: 'empty',
            t: '请选择服务器'
          });
        }
      } else {
        // 找大区
        var _selected = roleData.oriAreaData.STD_DATA;

        for (var _i7 = 0; _i7 < _selected.length; _i7++) {
          if (channel && _selected[_i7].c && channel != _selected[_i7].c) {
            continue;
          }

          if (system && _selected[_i7].s && system != _selected[_i7].s) {
            continue;
          }

          rtData.push({
            v: _selected[_i7].v,
            t: _selected[_i7].t
          });
        }

        if (rtData.length) {
          rtData.unshift({
            v: 'empty',
            t: '请选择大区'
          });
        }
      }

      return rtData;
    }; // 组织格式化数据


    var formatDataFunc = function formatDataFunc(index, data, _ref4) {
      var channel = _ref4.channel,
          system = _ref4.system,
          partition = _ref4.partition;

      if (index >= areaFields.length) {
        return;
      }

      var config = areaFields[index];
      data.fieldKey = config.fieldKey;
      data.fieldName = config.fieldName;
      data.requestKey = config.requestKey; // 渠道

      if (config.fieldKey == 'area') {
        data.data = [{
          v: 'empty',
          t: '请选择渠道'
        }];

        if (roleData.oriAreaData.STD_CHANNEL_DATA) {
          for (var _i8 = 0; _i8 < roleData.oriAreaData.STD_CHANNEL_DATA.length; _i8++) {
            data.data[_i8 + 1] = {
              t: roleData.oriAreaData.STD_CHANNEL_DATA[_i8].t,
              v: roleData.oriAreaData.STD_CHANNEL_DATA[_i8].v,
              subData: {}
            };
            formatDataFunc(index + 1, data.data[_i8 + 1].subData, {
              channel: roleData.oriAreaData.STD_CHANNEL_DATA[_i8].v,
              system: system,
              partition: partition
            });
          }
        }
      } else if (config.fieldKey == 'platid') {
        // 系统
        data.data = [{
          v: 'empty',
          t: '请选择系统'
        }];

        if (roleData.oriAreaData.STD_SYSTEM_DATA) {
          for (var _i9 = 0; _i9 < roleData.oriAreaData.STD_SYSTEM_DATA.length; _i9++) {
            data.data[_i9 + 1] = {
              t: roleData.oriAreaData.STD_SYSTEM_DATA[_i9].t,
              v: roleData.oriAreaData.STD_SYSTEM_DATA[_i9].v,
              subData: {}
            };
            formatDataFunc(index + 1, data.data[_i9 + 1].subData, {
              channel: channel,
              system: roleData.oriAreaData.STD_SYSTEM_DATA[_i9].v,
              partition: partition
            });
          }
        }
      } else if (config.fieldKey == 'partition') {
        // 大区
        data.data = [];
        var selectedData = filterData({
          channel: channel,
          system: system,
          partition: partition
        });

        if (selectedData && selectedData.length) {
          data.data = selectedData;

          for (var _i10 = 1; _i10 < data.data.length; _i10++) {
            data.data[_i10].subData = {};
            formatDataFunc(index + 1, data.data[_i10].subData, {
              channel: channel,
              system: system,
              partition: data.data[_i10].v
            });
          }
        }
      } else if (config.fieldKey == 'server') {
        // 服务器
        data.data = [];

        var _selectedData = filterData({
          channel: channel,
          system: system,
          partition: partition
        });

        if (_selectedData && _selectedData.length) {
          data.data = _selectedData; // 最深层为服务器层

          /*
          for (let i = 1; i < data.data.length; i++) {
          formatDataFunc(index + 1, data.data[i].subData, {
          channel: channel,
          system: system,
          partition: data.data[i].v
          });
          }
          */
        }
      } else {
        return;
      }
    }; // 初始化


    formatDataFunc(0, formatedAreaData, {
      channel: '',
      system: '',
      partition: ''
    }); // this.setRoleData({
    // 	formatedAreaData
    // });

    roleData = _objectSpread(_objectSpread({}, roleData), {}, {
      formatedAreaData: formatedAreaData
    });
    return roleData;
  },
  getAreaName: function getAreaName(roleData) {
    var areaIndex = roleData.areaIndex,
        areaFields = roleData.areaFields,
        formatedAreaData = roleData.formatedAreaData;
    var lastField = areaFields[areaFields.length - 1]; // 如果最后一项选项是系统，即无大区选项，areaname返回空

    if (lastField && lastField.requestKey === 'platid') {
      return '';
    }

    var areaName = '';

    function getCurName(index, areaData) {
      var _areaData$data = areaData.data,
          data = _areaData$data === void 0 ? [] : _areaData$data;
      var value = areaIndex[index];
      var curSelected = data.find(function (x) {
        return x.v === value;
      });

      if (curSelected) {
        if (index === areaIndex.length - 1) {
          areaName = curSelected.t || '';
        } else {
          getCurName(index + 1, curSelected.subData || {});
        }
      }
    }

    getCurName(0, formatedAreaData);
    return areaName;
  },
  getPIPInfo: function getPIPInfo(params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", new Promise(function (resolve) {
                var gameId = params.gameId;

                if (!gameId) {
                  resolve({
                    version: 'v.milojs.error.nogameId',
                    retCode: -10000,
                    msg: '未配置游戏ID，请检查！'
                  });
                }

                var LoginManager = new Login();
                LoginManager.checkLogin().then(function (res) {
                  loginStatus.syncToAME(function () {
                    var userInfo = res.userInfo;
                    var submitData = {};
                    var rand = "".concat(+new Date()).concat(Math.floor(Math.random() * 20000));
                    var authCallbackName = rand;
                    var extendParams = {};

                    if (LoginManager.isMSDKLogin()) {
                      var oMSDKLoginParams = LoginManager.getMSDKParams();
                      extendParams = oMSDKLoginParams;
                    }

                    if (isObject(params) && isString(params.url) && params.url) {
                      // 读取授权缓存失败，询问接口用户是否授权
                      submitData = {
                        sCloudApiName: 'ams.gameattr.roleauth',
                        url: getActivityReportUrl(params.url),
                        operation: 'query',
                        callback: authCallbackName,
                        game: gameId
                      }; // 实际请求地址

                      var roleURL = game2Url[gameId] ? game2Url[gameId] : urlDefault;
                      var baseUrl = "".concat(roleURL, "?").concat(_Object.serialize(_objectSpread(_objectSpread({}, submitData), extendParams)));
                      loader.loadScript({
                        url: baseUrl,
                        charset: 'gbk'
                      }).then(function (res) {
                        if (res === true) {
                          if (!isObject(window["role_auth_result_".concat(authCallbackName)])) {
                            resolve({
                              version: 'v.milojs.back.noreply',
                              retCode: -9999,
                              msg: '系统繁忙，请稍后重试！'
                            });
                          } else {
                            // add by weiztang Milo调试系统上报支持
                            window.MiloDebug && window.MiloDebug.setJsonp && window.MiloDebug.setJsonp(baseUrl, window["role_auth_result_".concat(authCallbackName)]);
                            resolve(window["role_auth_result_".concat(authCallbackName)]);
                          }
                        } else {
                          resolve({
                            version: 'v.milojs.back.notloaded',
                            retCode: -9999,
                            msg: '系统繁忙，请稍后重试！'
                          });
                        }
                      })["catch"](function (err) {
                        resolve({
                          version: 'v.milojs.back.catcherror',
                          retCode: -9999,
                          msg: err.errMsg
                        });
                      });
                    } else {
                      // 不指定就默认逻辑喽
                      var miloPipRoleCookie = cookie.get('miloPipRole') ? cookie.get('miloPipRole') : '';
                      var currentUser = userInfo.userUin ? userInfo.userUin : userInfo.openid;
                      var currentAllowUserStr = "".concat(currentUser, "|").concat(userInfo.acctype);

                      if (miloPipRoleCookie.indexOf(currentAllowUserStr) != -1) {
                        // 读取授权缓存成功
                        resolve({
                          version: 'v.milojs.cookie.miloPipRole',
                          retCode: 0,
                          msg: '已授权'
                        });
                      } else {
                        // 读取授权缓存失败，询问接口用户是否授权
                        submitData = {
                          sCloudApiName: 'ams.gameattr.roleauth',
                          url: getActivityReportUrl(location.href),
                          operation: 'query',
                          callback: authCallbackName,
                          game: gameId
                        }; // 实际请求地址

                        var _roleURL = game2Url[gameId] ? game2Url[gameId] : urlDefault;

                        var _baseUrl = "".concat(_roleURL, "?").concat(_Object.serialize(_objectSpread(_objectSpread({}, submitData), extendParams)));

                        loader.loadScript({
                          url: _baseUrl,
                          charset: 'gbk'
                        }).then(function (res) {
                          if (res === true) {
                            if (!isObject(window["role_auth_result_".concat(authCallbackName)])) {
                              resolve({
                                version: 'v.milojs.back.noreply',
                                retCode: -9999,
                                msg: '系统繁忙，请稍后重试！'
                              });
                            } else {
                              // add by weiztang Milo调试系统上报支持
                              window.MiloDebug && window.MiloDebug.setJsonp && window.MiloDebug.setJsonp(_baseUrl, window["role_auth_result_".concat(authCallbackName)]);
                              resolve(window["role_auth_result_".concat(authCallbackName)]);
                            }
                          } else {
                            resolve({
                              version: 'v.milojs.back.notloaded',
                              retCode: -9999,
                              msg: '系统繁忙，请稍后重试！'
                            });
                          }
                        })["catch"](function (err) {
                          resolve({
                            version: 'v.milojs.back.catcherror',
                            retCode: -9999,
                            msg: err.errMsg
                          });
                        });
                      }
                    }
                  });
                })["catch"](function () {
                  resolve({
                    version: 'v.milojs.back.nologin',
                    retCode: -10001,
                    msg: '未登录'
                  });
                });
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  setPIPInfo: function setPIPInfo(params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise(function (resolve) {
                var gameId = params.gameId;

                if (!gameId) {
                  resolve({
                    version: 'v.milojs.error.nogameId',
                    retCode: -10000,
                    msg: '未配置游戏ID，请检查！'
                  });
                }

                var LoginManager = new Login();
                LoginManager.checkLogin().then(function (res) {
                  loginStatus.syncToAME(function () {
                    var userInfo = res.userInfo;
                    var submitData = {};
                    var rand = "".concat(+new Date()).concat(Math.floor(Math.random() * 20000));
                    var authCallbackName = rand;

                    if (isObject(params) && isString(params.url) && params.url) {
                      // 后端记录授权状态，如果params.action为cancel
                      if (isString(params.action) && params.action === 'cancel') {
                        submitData = {
                          sCloudApiName: 'ams.gameattr.roleauth',
                          url: getActivityReportUrl(params.url),
                          operation: 'cancel',
                          callback: authCallbackName,
                          game: gameId
                        }; // 清除缓存

                        cookie.clear('miloPipRole');
                        cookie.clear('miloPipRole', location.host, location.pathname);
                      } else {
                        // 其他执行授权
                        submitData = {
                          sCloudApiName: 'ams.gameattr.roleauth',
                          url: getActivityReportUrl(params.url),
                          operation: 'auth',
                          callback: authCallbackName,
                          game: gameId
                        };
                      }
                    } else {
                      // 后端记录授权状态，如果params.action为cancel
                      if (isObject(params) && isString(params.action) && params.action === 'cancel') {
                        submitData = {
                          sCloudApiName: 'ams.gameattr.roleauth',
                          url: getActivityReportUrl(location.href),
                          operation: 'cancel',
                          callback: authCallbackName,
                          game: gameId
                        }; // 清除缓存

                        cookie.clear('miloPipRole');
                        cookie.clear('miloPipRole', location.host, location.pathname);
                      } else {
                        // 其他执行授权
                        submitData = {
                          sCloudApiName: 'ams.gameattr.roleauth',
                          url: getActivityReportUrl(location.href),
                          operation: 'auth',
                          callback: authCallbackName,
                          game: gameId
                        }; // 拼接缓存字符串

                        var currentUser = userInfo.userUin ? userInfo.userUin : userInfo.openid;
                        var currentAllowUserStr = "".concat(currentUser, "|").concat(userInfo.acctype);
                        var miloPipRoleCookie = cookie.get('miloPipRole') ? cookie.get('miloPipRole') : '';

                        if (!miloPipRoleCookie) {
                          miloPipRoleCookie = currentAllowUserStr;
                        } else if (miloPipRoleCookie.indexOf(currentAllowUserStr) == -1) {
                          miloPipRoleCookie = miloPipRoleCookie.concat(',', currentAllowUserStr);
                        } // 写入cookie


                        cookie.set('miloPipRole', miloPipRoleCookie, 7200, location.host, location.pathname);
                      }
                    }

                    var extendParams = {};

                    if (LoginManager.isMSDKLogin()) {
                      var oMSDKLoginParams = LoginManager.getMSDKParams();
                      extendParams = oMSDKLoginParams;
                    }

                    var roleURL = game2Url[gameId] ? game2Url[gameId] : urlDefault;
                    var baseUrl = "".concat(roleURL, "?").concat(_Object.serialize(_objectSpread(_objectSpread({}, submitData), extendParams)));
                    loader.loadScript({
                      url: baseUrl,
                      charset: 'gbk'
                    }).then(function (res) {
                      if (res === true) {
                        if (!isObject(window["role_auth_result_".concat(authCallbackName)])) {
                          resolve({
                            version: 'v.milojs.back.noreply',
                            retCode: -9999,
                            msg: '系统繁忙，请稍后重试！'
                          });
                        } else {
                          // add by weiztang Milo调试系统上报支持
                          window.MiloDebug && window.MiloDebug.setJsonp && window.MiloDebug.setJsonp(baseUrl, window["role_auth_result_".concat(authCallbackName)]);
                          resolve(window["role_auth_result_".concat(authCallbackName)]);
                        }
                      } else {
                        resolve({
                          version: 'v.milojs.back.notloaded',
                          retCode: -9999,
                          msg: '系统繁忙，请稍后重试！'
                        });
                      }
                    })["catch"](function (err) {
                      resolve({
                        version: 'v.milojs.back.catcherror',
                        retCode: -9999,
                        msg: err.errMsg
                      });
                    });
                  });
                })["catch"](function () {
                  resolve({
                    version: 'v.milojs.back.nologin',
                    retCode: -10001,
                    msg: '未登录'
                  });
                });
              }));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
};
export default RoleSelector;